export default __webpack_public_path__ + "static/media/sun.4f822ff0.png";